<template>
  <div class="col">
    <div class="pb-3 free-delivery-cities my-2 border-bottom"
         v-if="findAttributeOnSiteInfo('free_city_delivery').length > 0">
      <p class="font-weight-bold" v-t="'shopping_cart_general.free_delivery_cities'"></p>
      <span class="mx-2" v-for="item in findAttributeOnSiteInfo('free_city_delivery')">{{
          item.province.name
        }}-{{ item.name }}</span>
    </div>

    <div class="box my-2 p-3">
      <p v-t="'shopping_cart_general.description'"></p>
      <span class="order-description" v-t="'shopping_cart_general.description_on_payment_page'"></span>
    </div>


    <p>
      <span v-t="'shopping_cart_general.total'"></span>
      <span class="mx-1" v-html="$t('price.price', {currency: formatNumber(price_without_offer)})">     </span>
    </p>
    <p>
      <span v-t="'shopping_cart_general.offer'"></span>
      <span class="mx-1" v-html="$t('price.price', {currency: formatNumber(offer)})"></span>
    </p>
    <p v-if="showDeliveryPrice">
      <span v-t="'shopping_cart_general.delivery_price'"></span>

      <span class="mx-1">
        <template v-if="isNaN(parseInt(delivery))">{{ delivery }}</template>
        <template v-else>
          <span v-html="$t('price.price', {currency: formatNumber(parseInt(delivery))})"></span>
        </template>

      </span>

    </p>
    <p>
      <span v-t="'shopping_cart_general.paying_amount'"></span>
      <span class="mx-1" v-html="$t('price.price', {currency: formatNumber(price)})">    </span></p>


  </div>
</template>

<script>
import {findObjects, formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {
  subProducts,
  productPriceOnUnAuthShoppingCard
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {findHashProductOnLocalStorage} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart';
import {mapGetters} from "vuex";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";


export default {
  name: "UnAuthenticateSummary1",
  props: {
    products: {},
    showDeliveryPrice: {
      default: false
    },
    selectedCity: {
      default: null
    },
    getDeliveryEvent: {
      default: 0
    },
    disableSelectedCityWatch: {default: true}
  },
  data() {
    return {
      price: 0,
      offer: 0,
      delivery: this.$t('address.choose_city_and_province'),
      price_without_offer: 0,
    }
  },
  methods: {
    formatNumber,
    productPriceOnUnAuthShoppingCard,
    findHashProductOnLocalStorage,
    summary() {
      this.price = 0
      this.offer = 0
      this.price_without_offer = 0

      this.products.forEach(product => {
        subProducts(product).forEach(sub_product => {
          let item_in_storage = this.findHashProductOnLocalStorage(sub_product);
          if (item_in_storage !== undefined) {
            // convert local storage object to json to find item on it with index and extract quantity
            const offer = this.productPriceOnUnAuthShoppingCard(sub_product, product)['offer'] === null ? 0 : this.productPriceOnUnAuthShoppingCard(sub_product, product)['offer']
            let productQuantity = JSON.parse(localStorage.getItem('products'))[item_in_storage]['quantity'];
            let sumPriceWithoutOffer = parseInt(this.productPriceOnUnAuthShoppingCard(sub_product, product)['price']) * productQuantity
            let sumOffer = parseInt(offer) * productQuantity

            this.price_without_offer += sumPriceWithoutOffer
            this.offer += sumOffer
            this.price += (sumPriceWithoutOffer - sumOffer)
          }
        })
      })

      return true
    },
    async calculateDeliveryPrice() {

      this.summary()

      let form = [];

      this.products.forEach(product => {
        subProducts(product).forEach(sub_product => {
          let item_in_storage = this.findHashProductOnLocalStorage(sub_product);
          if (item_in_storage !== undefined) {
            const item = JSON.parse(localStorage.getItem('products'))[item_in_storage];

            let temp_item = {'quantity': item['quantity'], 'id': item['id']};

            if (item['sub_product_id'] != null) {
              temp_item['sub_product'] = item['sub_product_id']
            }
            form.push(temp_item)
          }
        })
      })
      this.delivery = 0
      form = {'product': form, ...this.selectedCity}

      if (localStorage.getItem('order_delivery') != null) {

        form['order_delivery'] = localStorage.getItem('order_delivery')

      }

      if (form.city_id != null && form.city_id != '') {
        await this.$store.dispatch('ShoppingCart/getDeliveryPrice', form).then(res => {
          let value = res.data.data.delivery_price;

          if (value == null) {

            this.delivery='خارج از محدوده ارسال'

          } else {
            value = parseInt(res.data.data.delivery_price);
            this.delivery = value
            this.price += value;
          }


        })
      }


    }
  },
  mounted() {
    window.addEventListener(`unauthenticatedShoppingCardData`, () => {
      this.summary()
    });
  },
  watch: {
    'products': {
      handler(newValue, oldValue) {
        this.summary()
      },
      deep: true
    },
    selectedCity: {
      handler(newValue, oldValue) {
        if (this.disableSelectedCityWatch) {
          let productItemChecker = this.products.map(item => item.id)
          if (productItemChecker.length > 0) {
            this.calculateDeliveryPrice()
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.box {
  background: #f8f9fa;
}

.order-description {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>